
export const Case = ({children}) => (
    children
)

export const Switch = ({condition, children}) => {
    return(
        condition ? children[0] : children[1]
    )
}